// =============================================
// 🔧 SERVICE DE CONFIGURATION DE LA POINTEUSE
// ===
const COMPANY_ID_KEY = "companyId";
const TOKEN_KEY = "pointeuseToken";
const COMPANY_INFORMATION_KEY = "companyInformation";
// ---------------------------------------------
// Vérifie si la pointeuse est configurée
// ---------------------------------------------
export const isConfigured = () => {
  return (
    localStorage.getItem(COMPANY_ID_KEY) !== null &&
    localStorage.getItem(TOKEN_KEY) !== null
  );
};

// ---------------------------------------------
// Récupère l'ID de l'entreprise
// ---------------------------------------------
export const getCompanyId = () => {
  return localStorage.getItem(COMPANY_ID_KEY);
};

// ---------------------------------------------
// Récupère les informations de l'entreprise
// ---------------------------------------------
export const getCompanyInformation = (): Record<string, unknown> => {
  try {
    const raw = localStorage.getItem(COMPANY_INFORMATION_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return {};
  }
};

/**
 * Indique si la page / liste des pointages est autorisée sur cette pointeuse.
 * Stocké au login (`pointeuseShowSessions` dans l’objet `company`).
 * Défaut : true (afficher) si absent ou erreur.
 */
export const getPointeuseShowSessions = (): boolean => {
  const info = getCompanyInformation();
  return info.pointeuseShowSessions !== false;
};
// ---------------------------------------------
// Définit l'ID de l'entreprise
// ---------------------------------------------
export const setCompanyId = (companyId: string) => {
  localStorage.setItem(COMPANY_ID_KEY, companyId);
};

// ---------------------------------------------
// Stocker le token de la pointeuse
// ---------------------------------------------
export const setPointeuseToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

// ---------------------------------------------
// Stocker les informations de l'entreprise dans le local storage
// ---------------------------------------------
export const setCompanyInformation = (companyInformation: any) => {
  const serialized =
    typeof companyInformation === "string"
      ? companyInformation
      : JSON.stringify(companyInformation);
  localStorage.setItem(COMPANY_INFORMATION_KEY, serialized);
};

/**
 * Met à jour le cache local avec la réponse du serveur (sync Paramètres),
 * comme après un login pointeuse : mêmes clés que `company` dans LoginConfig.
 */
export const applySyncedCompanyInformation = (payload: {
  id: string;
  name: string;
  address?: string | null;
  postalCode?: string | null;
  city?: string | null;
  phoneNumber?: string | null;
  siret?: string | null;
  pointeuseShowSessions: boolean;
}) => {
  setCompanyId(payload.id);
  setCompanyInformation({
    id: payload.id,
    name: payload.name,
    address: payload.address ?? undefined,
    postalCode: payload.postalCode ?? undefined,
    city: payload.city ?? undefined,
    phoneNumber: payload.phoneNumber ?? undefined,
    siret: payload.siret ?? undefined,
    pointeuseShowSessions: payload.pointeuseShowSessions,
  });
};

// ---------------------------------------------
// Récupérer le token de la pointeuse
// ---------------------------------------------
export const getPointeuseToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

// ---------------------------------------------
// Supprime l'ID de l'entreprise et le token
// ---------------------------------------------
export const resetConfiguration = () => {
  localStorage.removeItem(COMPANY_ID_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(COMPANY_INFORMATION_KEY);
};

// ---------------------------------------------
// Récupère la configuration de la pointeuse
// ---------------------------------------------
export const getConfiguration = () => {
  return {
    companyId: getCompanyId(),
    isConfigured: isConfigured(),
    companyInformation: getCompanyInformation(),
  };
};

